import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components/macro";

const ScrollToTop = () => {
  const location = useLocation();
  const isSitemap = location.pathname?.includes("sitemap");
  const isLogin = location.pathname?.includes("asparuh");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

const ScrollToTopContainer = styled.div``;

export default ScrollToTop;
